import { render } from "./SideNavItem.vue?vue&type=template&id=3bfc3b45"
import script from "./SideNavItem.vue?vue&type=script&lang=js"
export * from "./SideNavItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__